import { create } from 'zustand'

/**
 * Step-up: a session that signed in with a PIN must confirm the password
 * before sensitive admin actions (server answers 403 STEP_UP_REQUIRED). The
 * axios interceptor calls requestStepUp(), waits for this dialog, then
 * retries the original request — the user never repeats their click.
 */
interface StepUpState {
  open: boolean
  resolve: ((ok: boolean) => void) | null
}

export const useStepUpStore = create<StepUpState>(() => ({ open: false, resolve: null }))
let pending: Promise<boolean> | null = null

/** Opens the dialog (once, even for parallel requests); true when confirmed. */
export function requestStepUp(): Promise<boolean> {
  if (pending) return pending
  pending = new Promise<boolean>((resolve) => {
    useStepUpStore.setState({
      open: true,
      resolve: (ok) => {
        pending = null
        useStepUpStore.setState({ open: false, resolve: null })
        resolve(ok)
      },
    })
  })
  return pending
}
